//@ts-check
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Box } from '@material-ui/core';

const SimpleProgressBar = ({ classes, fillPercent, color, minimumPercent }) => {
  const percentDisplay = fillPercent > minimumPercent ? fillPercent : minimumPercent;

  return (
    <Box className={classes.container}>
      <Box className={classes.barContainer}>
        <div
          data-testid="simpleprogressbar-fill"
          className={cx(classes.bar, classes[color])}
          style={{ width: `${percentDisplay}%` }}
        />
      </Box>
    </Box>
  );
};

SimpleProgressBar.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  fillPercent: PropTypes.number,
  color: PropTypes.string,
  minimumPercent: PropTypes.number,
};

SimpleProgressBar.defaultProps = {
  classes: {},
  fillPercent: 0,
  color: 'green',
  minimumPercent: 0,
};

export default SimpleProgressBar;
